// Imports
// ------
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Row, Column } from '@waffl';

// Styles
// ------
import { Jacket, Cnt } from './styles';

// Component
// ------
const Content = ({ wysiwyg }) => (
	<Jacket>
		<Row isExpanded>
			<Column small={12} medium={10} pushOnMedium={1} mpad>
				<Cnt>{ReactHtmlParser(wysiwyg)}</Cnt>
			</Column>
		</Row>
	</Jacket>
);

export default Content;
